var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PlaceholderJewelry",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-placeholder-jewelry","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M157.8 70.1l32.1-36L156.1-.2H95.4L60 34.7l32.1 35.5C57 83.5 32 117.4 32 157.2c0 51.3 41.7 93 93 93s93-41.7 93-93c0-39.8-25.1-73.8-60.2-87.1zm-9.1-3.3c-2.2-.5-4.5-.9-6.8-1.3L158 38.9h15.6l-24.9 27.9zm-16-2.3c-2.5-.2-5.1-.3-7.7-.3-2.8 0-5.6.1-8.3.4-.1-.1-.1 0-.1 0l.4-.3-14.2-25.4h44.7l-15.3 25.3.5.3zM99.1 8.8h53.3l20.7 21.1H77.7L99.1 8.8zM76 38.9h16.4l15 26.7c-2.5.4-4.6.8-6.1 1.2L76 38.9zm49 202.3c-46.3 0-84-37.7-84-84 0-44.3 34.4-80.6 77.9-83.8 2-.1 4-.2 6.2-.2 1.9 0 3.7.1 5.5.2 43.7 2.9 78.3 39.4 78.3 83.8.1 46.3-37.6 84-83.9 84z"/>
  <path d="M125.2 81.5c-42.1 0-76.4 34.3-76.4 76.4 0 42.1 34.3 76.4 76.4 76.4s76.4-34.3 76.4-76.4c0-42.1-34.3-76.4-76.4-76.4zm0 143.8c-37.2 0-67.4-30.3-67.4-67.4 0-37.2 30.3-67.4 67.4-67.4 37.2 0 67.4 30.3 67.4 67.4 0 37.2-30.3 67.4-67.4 67.4z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/placeholder-jewelry.svg